import { useState, useContext } from 'react';

import { HOME_CHEF, BrandContext } from 'context/BrandContext';
import { generateRandomEmail, generateChicagoPhoneNumber } from 'helpers/internalSkipFunctions';
import { getBrandRoute } from 'helpers/routes';
import useBrand from 'hooks/useBrand';
import { STANDARD, TEMPO, FAMILY } from 'lib/constants';
import { SKIP_PATHS } from 'lib/constants/signUp';

const useInternalSkip = mealPlanSlug => {
  const { brand } = useContext(BrandContext);
  const [isInternalVisible, setIsInternalVisible] = useState(false);
  const isHomeChef = useBrand(HOME_CHEF);

  const isFamilyMealPlan = mealPlanSlug === FAMILY;
  const brandRoutes = getBrandRoute({ brand, isFamily: isFamilyMealPlan });

  const internalValues = () => ({
    introZipCode: '60607',
    introEmail: generateRandomEmail(),
    introSmsOptIn: false,
    introSmsPhoneNumber: generateChicagoPhoneNumber(),
    mealPlanSlug: isHomeChef ? STANDARD : TEMPO,
  });

  const pathMap = {
    [SKIP_PATHS.PREF_DIETARY]: brandRoutes.preferenceDietary,
    [SKIP_PATHS.PROMO]: brandRoutes.promo,
    [SKIP_PATHS.BOX_PEOPLE]: brandRoutes.boxRecommenderPeople,
    [SKIP_PATHS.BOX]: brandRoutes.box,
    [SKIP_PATHS.BILLING]: brandRoutes.billing,
    [SKIP_PATHS.THANK_YOU]: brandRoutes.thankyou,
    [SKIP_PATHS.INTRO]: brandRoutes.intro,
  };

  const handlePath = (history, to) => {
    const path = pathMap[to];
    if (path) {
      history.push(path);
    } else {
      // eslint-disable-next-line no-console
      console.error(`Skip Tool handlePath: Unknown path '${to}'`);
    }
  };

  return {
    generateRandomEmail,
    internalValues,
    handlePath,
    isInternalVisible,
    setIsInternalVisible,
  };
};

export default useInternalSkip;
